export const MOCK_PDF = {
  arquivoBase64: "abcdefghijklmnopqrstuvwxyz",
};
